import { FlexBox, Stack } from '@ardoq/layout';
import { Skeleton } from '@ardoq/loader';
import { r4 } from '@ardoq/design-tokens';
import { IconSize } from '@ardoq/icons';

const ROW_DELAYS = [0, 0.1, 0.2, 0.3, 0.4];
const ICON_SIZE = `${IconSize.MEDIUM}px`;

/**
 * Placeholder rows shown while organization documents load. Mirrors the layout
 * of a document row (icon + filename) so the list does not shift when the real
 * items arrive.
 */
export const DocumentListSkeleton = () => (
  <Stack gap="small">
    {ROW_DELAYS.map((delay, index) => (
      <FlexBox
        key={index}
        gap="small"
        align="center"
        paddingY="xsmall"
        paddingX="small"
      >
        <Skeleton
          width={ICON_SIZE}
          height={ICON_SIZE}
          borderRadius={r4}
          delay={delay}
        />
        <Stack gap="xsmall" flex={1}>
          <Skeleton height="16px" delay={delay} />
        </Stack>
      </FlexBox>
    ))}
  </Stack>
);
